import { useEffect, useState } from "react";
import {
  PRERENDER_VIEWPORT_WIDTH,
  isHydratingFromPrerender,
} from "src/common/prerender";

export const useWindowSize = () => {
  // 사전 렌더 HTML을 이어받는(hydrate) 첫 렌더는 저장 당시 폭으로 그려야 화면이 맞는다 → 마운트 직후 실제 폭으로 바꾼다
  const [size, setSize] = useState(() => ({
    width: isHydratingFromPrerender() ? PRERENDER_VIEWPORT_WIDTH : window.innerWidth,
  }));
  useEffect(() => {
    // 화면 크기가 바뀌면 해당 화면의 크기를 size state 로 바꿔주는 effect
    const handleResize = () => {
      setSize((prev) =>
        prev.width === window.innerWidth ? prev : { width: window.innerWidth },
      );
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return size;
};
